import { render, staticRenderFns } from "./performance-cmc-form-edit.vue?vue&type=template&id=f2a6310a"
import script from "./performance-cmc-form-edit.vue?vue&type=script&lang=js"
export * from "./performance-cmc-form-edit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports